// 定期便ビュー（中身/TMS・Supabase）。繰り返す便を「定期便マスタ」に一度登録し、
// 指定日（既定=本日）の便をワンクリックで trips に生成する。
// マスタ＝teikibin（id+raw）。生成便＝source:'teiki'・tripType:'regular'、ID=`TK-<masterId>-<YYYY-MM-DD>`（同日二重生成を防止）。
import { listDocs, getOne, upsert, remove, COLLECTIONS } from '../data/collections.js'
import { supabaseReady } from '../supabase.js'
import { loadVehicleTypes, vehicleTypeInput } from '../data/vehicleTypes.js'

const YEN = (n) => '¥' + Math.round(Number(n) || 0).toLocaleString('ja-JP')
const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]))
const pad = (n, l = 2) => String(n).padStart(l, '0')
const todayStr = () => { const d = new Date(); return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}` }
const weekdayOf = (ds) => new Date(ds + 'T00:00:00').getDay() // 0=日..6=土
const STAFF_BASE = ['片山', '山本', '近藤', '木下', '田中', '伊藤', '深瀬', '仙台営業所']
const WD = ['日', '月', '火', '水', '木', '金', '土']

const T = {
  el: null, ctx: null, user: null, myStaff: '', online: false, fetchError: false,
  tpl: [], cust: [], part: [], drv: [], custById: {}, partById: {}, drvById: {},
  vtypes: [],
  form: null, saving: '', genDate: '', gen: null,
}
const byCode = (a, b) => (Number(a.code) || 0) - (Number(b.code) || 0) || String(a.code || a.id).localeCompare(String(b.code || b.id), 'ja')
const idMap = (arr) => { const m = {}; for (const x of arr) m[x.id] = x; return m }
const newTplId = () => `TP${Date.now()}${pad(Math.floor(Math.random() * 100))}`

function styleOnce() {
  if (document.getElementById('tk-style')) return
  const s = document.createElement('style'); s.id = 'tk-style'
  s.textContent = `
  .tk{display:flex;flex-direction:column;gap:12px}
  .tk-bar{display:flex;align-items:center;gap:10px;flex-wrap:wrap}
  .tk-btn{font-family:inherit;font-size:12.5px;font-weight:700;color:var(--text);background:var(--head);border:1px solid var(--e1);border-radius:8px;padding:7px 13px;cursor:pointer}
  .tk-btn:hover{background:var(--head)}.tk-btn:disabled{opacity:.5;cursor:default}
  .tk-btn.primary{background:var(--accent-fill);color:#fff;border-color:var(--accent-fill)}.tk-btn.primary:hover{background:var(--accent-fill)}
  .tk-btn.ghost{background:var(--card)}.tk-btn.danger{background:var(--neg);color:var(--bg);border-color:var(--neg)}
  .tk-btn.warn{background:var(--pos);color:var(--bg);border-color:var(--pos)}.tk-btn.warn:hover{background:var(--pos)}
  .tk-save{font-size:11px;color:var(--pos);background:var(--head);border:1px solid var(--e1);border-radius:999px;padding:3px 10px}
  .tk-panel{border:1px solid var(--e1);border-radius:12px;background:var(--card);padding:12px 14px;display:flex;flex-direction:column;gap:9px}
  .tk-panel h3{margin:0;font-size:12.5px;color:var(--text)}
  .tk-gen{display:flex;align-items:center;gap:10px;flex-wrap:wrap}
  .tk-gen input[type=date]{font-family:inherit;font-size:13px;padding:6px 8px;border:1px solid var(--e1);border-radius:7px}
  .tk-wrap{border:1px solid var(--e1);border-radius:12px;overflow:hidden;background:var(--card)}
  .tk-wrap .cap{padding:9px 13px;font-size:12px;font-weight:700;color:var(--muted);background:var(--head);border-bottom:1px solid var(--e1)}
  .tk-scroll{max-height:52vh;overflow:auto}
  table.tk-tbl{width:100%;border-collapse:collapse;font-size:11.5px}
  .tk-tbl th,.tk-tbl td{padding:6px 9px;border-bottom:1px solid var(--e1);text-align:left;white-space:nowrap}
  .tk-tbl th{position:sticky;top:0;background:var(--head);color:var(--text);font-size:10.5px}
  .tk-tbl td.n{text-align:right;font-variant-numeric:tabular-nums}
  .tk-badge{font-size:9.5px;font-weight:700;border-radius:4px;padding:1px 6px}
  .tk-note{font-size:11px;color:var(--muted);line-height:1.6}
  .tk-modal{position:fixed;inset:0;background:rgba(0,0,0,.45);display:flex;align-items:center;justify-content:center;z-index:50;padding:20px}
  .tk-card{background:var(--card);border-radius:14px;width:min(760px,96vw);max-height:90vh;display:flex;flex-direction:column;border:1px solid var(--e1);box-shadow:inset 0 1px 0 var(--hilite);overflow:hidden}
  .tk-card-h{padding:13px 16px;font-size:14px;font-weight:800;color:var(--text);border-bottom:1px solid var(--e1);display:flex;gap:10px;align-items:baseline}
  .tk-card-scroll{overflow:auto;padding:12px 16px}
  .tk-card-f{padding:12px 16px;display:flex;gap:10px;align-items:center;border-top:1px solid var(--e1)}
  .tk-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px 14px}
  .tk-fld{display:flex;flex-direction:column;gap:3px}
  .tk-lab{font-size:11px;font-weight:700;color:var(--text)}
  .tk-fld input,.tk-fld select{font-family:inherit;font-size:13px;border:1px solid var(--e1);border-radius:7px;padding:6px 8px;background:var(--card);color:var(--text)}
  .tk-fld input.num{text-align:right;font-variant-numeric:tabular-nums}
  .tk-hint{font-size:10px;color:var(--muted)}
  .tk-seg{display:inline-flex;background:var(--head);border-radius:9px;padding:3px}
  .tk-seg button{border:0;background:transparent;font-family:inherit;font-size:12.5px;font-weight:700;color:var(--text);padding:6px 13px;border-radius:7px;cursor:pointer}
  .tk-seg button.on{background:var(--accent-fill);color:#fff}
  .tk-wd{display:flex;gap:4px;flex-wrap:wrap}
  .tk-wd label{display:flex;align-items:center;gap:3px;font-size:12px;border:1px solid var(--e1);border-radius:7px;padding:4px 8px;cursor:pointer;user-select:none}
  .tk-wd label.on{background:var(--accent-fill);color:#fff;border-color:var(--accent-fill)}
  .tk-err{margin-top:10px;font-size:12px;color:var(--neg);font-weight:700}
  `
  document.head.appendChild(s)
}

export async function renderTeiki(el, ctx = {}) {
  styleOnce()
  T.el = el; T.ctx = ctx; T.user = ctx.user || null
  T.online = !ctx.demo && supabaseReady
  T.fetchError = false
  T.form = null; T.saving = ''; T.gen = null; T.genDate = todayStr()
  el.innerHTML = '<div class="tk-note" style="padding:16px">読込中…</div>'
  T.tpl = []; T.cust = []; T.part = []; T.drv = []
  if (T.online) {
    try {
      const [tpl, cust, part, drv, vtypes] = await Promise.all([
        listDocs(COLLECTIONS.teikibin), listDocs(COLLECTIONS.customers), listDocs(COLLECTIONS.partners), listDocs(COLLECTIONS.drivers), loadVehicleTypes(),
      ])
      T.tpl = tpl || []; T.vtypes = vtypes || []
      T.cust = (cust || []).slice().sort(byCode); T.part = (part || []).slice().sort(byCode); T.drv = (drv || []).slice().sort(byCode)
      T.custById = idMap(T.cust); T.partById = idMap(T.part); T.drvById = idMap(T.drv)
      if (T.user && T.user.email) { try { const me = await getOne('users', T.user.email); T.myStaff = (me && me.staff) || '' } catch (e) {} }
    } catch { T.online = false; T.fetchError = true }
  }
  // 取得失敗は「未サインイン（閲覧のみ）」でも「定期便0件」でもない。黙って劣化させず is-error を主表示にする
  // （PR #52 と同型。teiki は同梱サンプルを持たないため、必要なのはこの短絡だけ）
  if (T.fetchError) { paintFetchError(); return }
  paint()
}

// 取得失敗の主表示。マスタ一覧・生成パネルは描かない（0件でも未サインインでもないため）
function paintFetchError() {
  T.el.innerHTML = '<section class="tk"><div class="ct-state is-error"><b class="ct-state__t">定期便マスタを読み込めませんでした</b><span>登録済みの定期便を取得できていません。この状態では便の生成もできません。接続を確認して再試行してください</span><button type="button" class="btn" id="tk-retry">再試行</button></div></section>'
  const retry = T.el.querySelector('#tk-retry'); if (retry) retry.addEventListener('click', () => { renderTeiki(T.el, T.ctx) })
}

// ── フォーム ─────────────────────────────────────────
function blankTpl() {
  return { mode: 'add', id: '', label: '', kind: 'own', staff: T.myStaff || '',
    customerId: '', origin: '', dest: '', item: '', vehicleClass: '',
    driverId: '', carNo: '', fare: '', tollBill: '', partnerId: '', charterCost: '', tollPay: '',
    ptype: 'weekly', weekdays: [1, 2, 3, 4, 5], activeFrom: '', activeTo: '', active: true, err: '' }
}
function tplToForm(t) {
  return { mode: 'edit', id: t.id, label: t.label || '', kind: t.kind === 'charter' ? 'charter' : 'own', staff: t.staff || '',
    customerId: t.customerId || '', origin: t.origin || '', dest: t.dest || '', item: t.item || '', vehicleClass: t.vehicleClass || '',
    driverId: t.driverId || '', carNo: t.carNo || '', fare: t.fare != null ? t.fare : '', tollBill: t.tollBill != null ? t.tollBill : '',
    partnerId: t.partnerId || '', charterCost: t.charterCost != null ? t.charterCost : '', tollPay: t.tollPay != null ? t.tollPay : '',
    ptype: (t.pattern && t.pattern.type) || 'weekly', weekdays: (t.pattern && t.pattern.weekdays) ? t.pattern.weekdays.slice() : [1, 2, 3, 4, 5],
    activeFrom: t.activeFrom || '', activeTo: t.activeTo || '', active: t.active !== false, err: '' }
}
const optList = (arr, sel, fmt) => ['<option value=""></option>'].concat(arr.map((x) => `<option value="${esc(x.id)}"${x.id === sel ? ' selected' : ''}>${esc(fmt(x))}</option>`)).join('')
const partyFmt = (c) => `${c.code != null ? c.code : ''}${c.branchNo != null && c.branchNo !== '' ? '-' + c.branchNo : ''}  ${c.formal || c.name || c.id}`
const drvFmt = (d) => `${d.code || d.id}  ${d.name || ''}`
const field = (label, control, hint) => `<label class="tk-fld"><span class="tk-lab">${esc(label)}</span>${control}${hint ? `<span class="tk-hint">${hint}</span>` : ''}</label>`

function renderForm() {
  const f = T.form, own = f.kind === 'own'
  const title = f.mode === 'add' ? '定期便を登録' : '定期便を編集'
  const staffOpts = [...new Set([...STAFF_BASE, f.staff].filter(Boolean))]
  return `
  <div class="tk-modal" id="tk-modal">
    <div class="tk-card">
      <div class="tk-card-h">${title}<span class="tk-note">${f.mode === 'edit' ? 'ID: ' + esc(f.id) : '登録すると指定日にワンクリックで便を生成できます'}</span></div>
      <div class="tk-card-scroll">
        <div class="tk-seg" style="margin:2px 2px 12px">
          <button data-kind="own" class="${own ? 'on' : ''}">自社便</button>
          <button data-kind="charter" class="${!own ? 'on' : ''}">傭車</button>
        </div>
        <div class="tk-grid">
          ${field('定期便名（任意）', `<input data-f="label" value="${esc(f.label)}" placeholder="例: 月木 堺→東京">`)}
          ${field('担当', `<select data-f="staff"><option value=""></option>${staffOpts.map((s) => `<option value="${esc(s)}"${s === f.staff ? ' selected' : ''}>${esc(s)}</option>`).join('')}</select>`)}
          ${field('得意先', `<select data-f="customerId">${optList(T.cust, f.customerId, partyFmt)}</select>`, 'CD＋枝番で選択→正式名称は自動')}
          ${field('車種', vehicleTypeInput('data-f="vehicleClass"', f.vehicleClass, T.vtypes, 'tk-vtypes'))}
          ${field('発地', `<input data-f="origin" value="${esc(f.origin)}">`)}
          ${field('着地', `<input data-f="dest" value="${esc(f.dest)}">`)}
          ${field('品名', `<input data-f="item" value="${esc(f.item)}">`)}
          ${own
            ? field('乗務員', `<select data-f="driverId">${optList(T.drv, f.driverId, drvFmt)}</select>`, '固定の乗務員（当日変更は生成後に編集）')
            : field('協力会社 *', `<select data-f="partnerId">${optList(T.part, f.partnerId, partyFmt)}</select>`)}
          ${own
            ? field('車番（任意）', `<input data-f="carNo" value="${esc(f.carNo)}" placeholder="例: 55">`)
            : field('傭車金額', `<input type="number" data-f="charterCost" class="num" value="${esc(f.charterCost)}">`)}
          ${field('運賃 *', `<input type="number" data-f="fare" class="num" value="${esc(f.fare)}">`)}
          ${own
            ? field('請通行料（任意）', `<input type="number" data-f="tollBill" class="num" value="${esc(f.tollBill)}">`)
            : field('支通行料（任意）', `<input type="number" data-f="tollPay" class="num" value="${esc(f.tollPay)}">`)}
        </div>
        <div style="margin-top:12px">
          <div class="tk-lab" style="margin-bottom:5px">運行パターン</div>
          <div class="tk-seg" style="margin-bottom:8px">
            <button data-ptype="weekly" class="${f.ptype === 'weekly' ? 'on' : ''}">曜日指定</button>
            <button data-ptype="daily" class="${f.ptype === 'daily' ? 'on' : ''}">毎日</button>
          </div>
          ${f.ptype === 'weekly' ? `<div class="tk-wd">${WD.map((w, i) => `<label class="${f.weekdays.includes(i) ? 'on' : ''}"><input type="checkbox" data-wd="${i}" ${f.weekdays.includes(i) ? 'checked' : ''} style="display:none">${w}</label>`).join('')}</div>` : '<div class="tk-hint">毎日（土日祝も含む）生成対象になります</div>'}
        </div>
        <div class="tk-grid" style="margin-top:12px">
          ${field('有効開始（任意）', `<input type="date" data-f="activeFrom" value="${esc(f.activeFrom)}">`, '空欄なら制限なし')}
          ${field('有効終了（任意）', `<input type="date" data-f="activeTo" value="${esc(f.activeTo)}">`, '空欄なら制限なし')}
        </div>
        ${f.err ? `<div class="tk-err">${esc(f.err)}</div>` : ''}
      </div>
      <div class="tk-card-f">
        ${f.mode === 'edit' ? `<button class="tk-btn ${f.active ? 'ghost' : 'warn'}" id="tk-toggle">${f.active ? '停止する' : '再開する'}</button><button class="tk-btn danger" id="tk-del">削除</button>` : ''}
        <span style="flex:1"></span>
        <button class="tk-btn" id="tk-cancel">閉じる</button>
        <button class="tk-btn primary" id="tk-save">${esc(T.saving || '保存')}</button>
      </div>
    </div>
  </div>`
}
function wireForm() {
  const el = T.el
  el.querySelectorAll('#tk-modal [data-kind]').forEach((b) => b.addEventListener('click', () => { T.form.kind = b.dataset.kind; T.form.err = ''; paint() }))
  el.querySelectorAll('#tk-modal [data-ptype]').forEach((b) => b.addEventListener('click', () => { T.form.ptype = b.dataset.ptype; paint() }))
  el.querySelectorAll('#tk-modal [data-wd]').forEach((c) => c.addEventListener('change', () => {
    const i = Number(c.dataset.wd); const set = new Set(T.form.weekdays)
    if (c.checked) set.add(i); else set.delete(i)
    T.form.weekdays = [...set].sort(); paint()
  }))
  el.querySelectorAll('#tk-modal [data-f]').forEach((inp) => {
    const ev = inp.tagName === 'SELECT' ? 'change' : 'input'
    inp.addEventListener(ev, () => { T.form[inp.dataset.f] = inp.value })
  })
  const save = el.querySelector('#tk-save'); if (save) save.addEventListener('click', saveTpl)
  const cancel = el.querySelector('#tk-cancel'); if (cancel) cancel.addEventListener('click', () => { T.form = null; paint() })
  const modal = el.querySelector('#tk-modal'); if (modal) modal.addEventListener('mousedown', (e) => { if (e.target === modal) { T.form = null; paint() } })
  const tog = el.querySelector('#tk-toggle'); if (tog) tog.addEventListener('click', toggleActive)
  const del = el.querySelector('#tk-del'); if (del) del.addEventListener('click', delTpl)
}

async function saveTpl() {
  const f = T.form
  if (f.fare === '' || f.fare == null) { f.err = '運賃を入力してください'; paint(); return }
  if (f.kind === 'charter' && !f.partnerId) { f.err = '協力会社を選択してください（傭車）'; paint(); return }
  if (f.ptype === 'weekly' && (!f.weekdays || !f.weekdays.length)) { f.err = '運行する曜日を選んでください'; paint(); return }
  const id = f.id || newTplId()
  const cust = f.customerId ? T.custById[f.customerId] : null
  const doc = {
    label: f.label || '', kind: f.kind, staff: f.staff || '', vehicleClass: f.vehicleClass || '',
    origin: f.origin || '', dest: f.dest || '', item: f.item || '',
    fare: Number(f.fare) || 0, tollBill: Number(f.tollBill) || 0,
    customerId: f.customerId || '', customerName: cust ? (cust.name || '') : '', customerFormal: cust ? (cust.formal || cust.name || '') : '',
    pattern: { type: f.ptype, weekdays: f.ptype === 'weekly' ? f.weekdays : [] },
    activeFrom: f.activeFrom || '', activeTo: f.activeTo || '', active: f.active !== false, updatedAt: new Date().toISOString(),
  }
  if (cust) { doc.customerCode = cust.code; if (cust.branchNo != null) doc.customerBranchNo = cust.branchNo }
  if (f.kind === 'own') {
    const drv = f.driverId ? T.drvById[f.driverId] : null
    doc.driverId = f.driverId || ''; doc.driverName = drv ? (drv.name || '') : ''; doc.driverCode = drv ? String(drv.code || drv.id) : ''
    doc.carNo = f.carNo || ''; doc.partnerId = ''; doc.partnerName = ''; doc.partnerFormal = ''; doc.charterCost = 0; doc.tollPay = 0
  } else {
    const pt = f.partnerId ? T.partById[f.partnerId] : null
    doc.partnerId = f.partnerId || ''; doc.partnerName = pt ? (pt.name || '') : ''; doc.partnerFormal = pt ? (pt.formal || pt.name || '') : ''
    if (pt) { doc.partnerCode = pt.code; if (pt.branchNo != null) doc.partnerBranchNo = pt.branchNo }
    doc.charterCost = Number(f.charterCost) || 0; doc.tollPay = Number(f.tollPay) || 0
    doc.driverId = ''; doc.driverName = ''; doc.driverCode = ''; doc.carNo = ''
  }
  try {
    T.saving = '保存中…'; paint()
    await upsert(COLLECTIONS.teikibin, id, doc)
    T.tpl = await listDocs(COLLECTIONS.teikibin)
    T.form = null; T.saving = '保存しました ✓'; paint()
    setTimeout(() => { T.saving = ''; paint() }, 1600)
  } catch (e) { T.saving = ''; f.err = '保存に失敗しました（サインイン状態と許可アカウントを確認）'; paint() }
}
async function toggleActive() {
  const f = T.form; if (!f.id) return
  try { T.saving = '更新中…'; paint(); await upsert(COLLECTIONS.teikibin, f.id, { active: !(f.active !== false), updatedAt: new Date().toISOString() }); T.tpl = await listDocs(COLLECTIONS.teikibin); T.form = null; T.saving = '更新しました ✓'; paint(); setTimeout(() => { T.saving = ''; paint() }, 1400) } catch (e) { T.saving = ''; f.err = '更新に失敗しました'; paint() }
}
async function delTpl() {
  const f = T.form; if (!f.id) return
  if (!f._confirmDel) { f._confirmDel = true; paint(); return }
  try { T.saving = '削除中…'; paint(); await remove(COLLECTIONS.teikibin, f.id); T.tpl = await listDocs(COLLECTIONS.teikibin); T.form = null; T.saving = '削除しました ✓'; paint(); setTimeout(() => { T.saving = ''; paint() }, 1400) } catch (e) { T.saving = ''; f.err = '削除に失敗しました'; paint() }
}
function openEdit(id) { const t = T.tpl.find((x) => x.id === id); if (!t) return; T.form = tplToForm(t); paint() }

// ── 生成 ─────────────────────────────────────────
function matchDate(t, ds) {
  if (t.active === false) return false
  if (t.activeFrom && ds < t.activeFrom) return false
  if (t.activeTo && ds > t.activeTo) return false
  const p = t.pattern || {}
  if (p.type === 'daily') return true
  const wd = weekdayOf(ds)
  return Array.isArray(p.weekdays) && p.weekdays.includes(wd)
}
function tripFromTemplate(t, ds, tripId) {
  const own = t.kind !== 'charter'
  const doc = {
    source: 'teiki', tripType: 'regular', teikiId: t.id, manageId: tripId,
    date: ds, unloadDate: ds, month: ds.slice(0, 7), staff: t.staff || '', kind: own ? 'own' : 'charter', voided: false,
    customerName: t.customerName || '', customerFormal: t.customerFormal || t.customerName || '',
    origin: t.origin || '', dest: t.dest || '', item: t.item || '', vehicleClass: t.vehicleClass || '',
    fare: Number(t.fare) || 0, tollBill: Number(t.tollBill) || 0, updatedAt: new Date().toISOString(),
  }
  if (t.customerCode != null) { doc.customerCode = t.customerCode; if (t.customerBranchNo != null) doc.customerBranchNo = t.customerBranchNo }
  if (own) {
    doc.driverName = t.driverName || ''; doc.driverCode = t.driverCode || ''; doc.carNo = t.carNo || ''; doc.vehicleId = t.carNo || ''
    doc.partnerName = ''; doc.partnerFormal = ''; doc.charterCost = 0; doc.tollPay = 0; doc.tollCost = doc.tollBill
  } else {
    doc.partnerName = t.partnerName || ''; doc.partnerFormal = t.partnerFormal || t.partnerName || ''
    if (t.partnerCode != null) { doc.partnerCode = t.partnerCode; if (t.partnerBranchNo != null) doc.partnerBranchNo = t.partnerBranchNo }
    doc.charterCost = Number(t.charterCost) || 0; doc.tollPay = Number(t.tollPay) || 0
    doc.driverName = ''; doc.driverCode = ''; doc.carNo = ''; doc.vehicleId = ''; doc.tollCost = doc.tollPay
  }
  return doc
}
async function generate() {
  const ds = T.genDate
  if (!ds) return
  const matched = T.tpl.filter((t) => matchDate(t, ds))
  T.gen = { running: true, ds, created: 0, skipped: 0, errors: 0, items: [] }; paint()
  for (const t of matched) {
    const tripId = `TK-${t.id}-${ds}`
    try {
      const exists = await getOne('trips', tripId)
      if (exists && exists.voided !== true) { T.gen.skipped++; T.gen.items.push({ label: t.label || `${t.origin}→${t.dest}`, st: 'skip' }); continue }
      await upsert('trips', tripId, tripFromTemplate(t, ds, tripId))
      T.gen.created++; T.gen.items.push({ label: t.label || `${t.origin}→${t.dest}`, st: 'new' })
    } catch (e) { T.gen.errors++; T.gen.items.push({ label: t.label || `${t.origin}→${t.dest}`, st: 'err' }) }
  }
  T.gen.running = false; paint()
}

// ── 描画 ─────────────────────────────────────────
const patLabel = (t) => { const p = t.pattern || {}; return p.type === 'daily' ? '毎日' : (Array.isArray(p.weekdays) ? p.weekdays.map((i) => WD[i]).join('') : '—') }
function paint() {
  const el = T.el
  const rows = T.tpl.slice().sort((a, b) => String(a.label || a.id).localeCompare(String(b.label || b.id), 'ja'))
  const active = rows.filter((t) => t.active !== false).length
  const g = T.gen
  el.innerHTML = `
    <section class="tk">
      <div class="tk-bar">
        <button class="tk-btn primary" id="tk-add" ${T.online ? '' : 'disabled'}>＋定期便を登録</button>
        <button class="tk-btn" id="tk-back">← 配車ボードへ</button>
        ${T.saving ? `<span class="tk-save">${esc(T.saving)}</span>` : ''}
        ${T.online ? '' : '<span class="tk-note">閲覧のみ（サインインで登録・生成）。</span>'}
      </div>
      <div class="tk-panel">
        <h3>当日の便を生成</h3>
        <div class="tk-gen">
          <input type="date" id="tk-gendate" value="${esc(T.genDate)}">
          <button class="tk-btn warn" id="tk-gen" ${T.online ? '' : 'disabled'}>この日の定期便を生成</button>
          <span class="tk-note">対象日に一致する定期便を <b>trips</b> に作成します（同日ぶんが既にあればスキップ＝二重計上なし）。生成後は配車ボードで個別に編集・取消できます。</span>
        </div>
        ${g ? `<div class="tk-note">${esc(g.ds)}：<b style="color:var(--pos)">生成 ${g.created}</b> / スキップ ${g.skipped}${g.errors ? ` / <span style="color:var(--neg)">失敗 ${g.errors}</span>` : ''}${g.running ? '（生成中…）' : ''}${g.items.length ? '　' + g.items.map((it) => `${esc(it.label)}<span class="tk-badge" style="background:${it.st === 'new' ? 'var(--head)' : it.st === 'skip' ? 'var(--head)' : 'transparent'}">${it.st === 'new' ? '新規' : it.st === 'skip' ? '既存' : '失敗'}</span>`).join('　') : ''}</div>` : ''}
      </div>
      <div class="tk-wrap">
        <div class="cap">定期便マスタ（${rows.length}件・稼働 ${active}／行クリックで編集）</div>
        <div class="tk-scroll"><table class="tk-tbl">
          <thead><tr><th>定期便名</th><th>区分</th><th>担当</th><th>得意先</th><th>発</th><th>着</th><th>車種</th><th>乗務員/協力</th><th class="n">運賃</th><th>パターン</th><th>状態</th></tr></thead>
          <tbody>${rows.map((t) => `<tr class="clk" data-edit="${esc(t.id)}" style="cursor:pointer">
            <td>${esc(t.label || '—')}</td>
            <td><span class="tk-badge" style="color:${t.kind === 'charter' ? 'var(--signal)' : 'var(--text)'};background:${t.kind === 'charter' ? 'transparent' : 'transparent'}">${t.kind === 'charter' ? '傭車' : '自社便'}</span></td>
            <td>${esc(t.staff || '')}</td>
            <td>${esc(t.customerFormal || t.customerName || '')}</td>
            <td>${esc(t.origin || '')}</td>
            <td>${esc(t.dest || '')}</td>
            <td>${esc(t.vehicleClass || '')}</td>
            <td>${esc(t.kind === 'charter' ? (t.partnerFormal || t.partnerName || '') : (t.driverName || ''))}</td>
            <td class="n">${YEN(t.fare)}</td>
            <td>${esc(patLabel(t))}</td>
            <td>${t.active !== false ? '<span class="tk-badge" style="color:var(--pos);background:var(--head)">稼働</span>' : '<span class="tk-badge" style="color:var(--head);background:var(--head)">停止</span>'}</td>
          </tr>`).join('') || '<tr><td colspan="11" class="tk-note" style="padding:14px">まだ定期便がありません。「＋定期便を登録」から追加してください。</td></tr>'}</tbody>
        </table></div>
      </div>
      <div class="tk-note">定期便は「一度登録→対象日にワンクリックで生成」。運賃・区間・車種・担当・乗務員を保存しておけば、毎日の再入力が不要になります。祝日運休や単発の変更は、生成した便を配車ボードで個別に編集・取消してください。</div>
      ${T.form ? renderForm() : ''}
    </section>`
  const add = el.querySelector('#tk-add'); if (add) add.addEventListener('click', () => { T.form = blankTpl(); paint() })
  const back = el.querySelector('#tk-back'); if (back) back.addEventListener('click', () => { location.hash = '#/dispatch' })
  const gd = el.querySelector('#tk-gendate'); if (gd) gd.addEventListener('change', (e) => { T.genDate = e.target.value })
  const gen = el.querySelector('#tk-gen'); if (gen) gen.addEventListener('click', generate)
  el.querySelectorAll('tr[data-edit]').forEach((tr) => tr.addEventListener('click', () => openEdit(tr.dataset.edit)))
  if (T.form) wireForm()
}
